import React, { FC } from 'react'
import { MetaTags } from '@ynap/meta-tags';

type Props = {
    title: string
    brandId: string
    titleDelimiter?: string
}
export const MetaData: FC<Props> = ({ title, titleDelimiter = ' | ', brandId })=>{
    const metaData  = {
        titles: [ title ],
        titleDelimiter,
        brandId: brandId,
    }

    return <MetaTags metaData={metaData} />
}

export default MetaData;